<section class="mega-menu-skeleton">
  <!-- product category -->
  <ul class="mega-menu-skeleton__categories">
    <ngx-skeleton-loader
      count="6"
      class="flex flex-col gap-20"
      [theme]="{
        width: '10em',
        height: '1.8em',
        'border-radius': '0.325em',
      }"></ngx-skeleton-loader>
  </ul>

  <!-- product type -->
  <ul class="mega-menu-skeleton__sub-categories">
    <ngx-skeleton-loader
      count="6"
      class="flex flex-col gap-20"
      [theme]="{
        width: '14em',
        height: '1.8em',
        'border-radius': '0.325em',
      }"></ngx-skeleton-loader>
  </ul>

  <!-- products categories -->
  <div class="mega-menu-skeleton__products-container">
    <ul class="mega-menu-skeleton__products-types">
      <ngx-skeleton-loader
        count="6"
        class="flex flex-col gap-20"
        [theme]="{
          width: '16em',
          height: '1.8em',
          'border-radius': '0.325em',
        }"></ngx-skeleton-loader>
    </ul>
  </div>
</section>
